import ExpertAvatar from '@ai/common/src/components/ExpertAvatar';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Paper, Stack, Typography } from '@mui/material';
import { activeDialogsStore } from '@store/ActiveDialogsStore';
import { SnackbarKey, useSnackbar } from 'notistack';
import { forwardRef } from 'react';

interface Props {
  snackbarKey: SnackbarKey;
  expertImageId: string;
  expertName: string;
  title: string;
  message?: string;
  dialogId: string;
}

export const ActiveDialogSnackbar = forwardRef<HTMLDivElement, Props>(
  ({ snackbarKey, expertImageId, expertName, title, message, dialogId }, ref) => {
    const { closeSnackbar } = useSnackbar();

    const handleClick = () => {
      activeDialogsStore.setPendingDialogId(dialogId);
      window.location.hash = '#/active-dialogs';
      closeSnackbar(snackbarKey);
    };

    return (
      <Paper
        ref={ref}
        elevation={5}
        sx={{
          p: 1,
          pr: 1,
          cursor: 'pointer',
          width: 360,
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          borderRadius: 3,
          backgroundColor: (theme) => theme.palette.primary.main,
        }}
        onClick={handleClick}
      >
        <ExpertAvatar size={60} src={expertImageId} />
        <Stack flexGrow={1} overflow="hidden">
          <Typography lineHeight={1} fontWeight="bold" fontSize={14} noWrap color="white">
            {title}
          </Typography>

          <Typography color="white" fontSize={12} noWrap sx={{ opacity: 0.85 }}>
            Эксперт: {expertName}
          </Typography>

          {message && (
            <Typography color="white" fontSize={14} noWrap>
              {message}
            </Typography>
          )}
        </Stack>
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            closeSnackbar(snackbarKey);
          }}
        >
          <CloseIcon fontSize="small" sx={{ color: 'white' }} />
        </IconButton>
      </Paper>
    );
  },
);
